import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "deplierred",
  "use": "deplierred-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol viewBox=\"0 0 34 34\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"deplierred\">\n<circle cx=\"17\" cy=\"17\" r=\"17\" transform=\"rotate(-180 17 17)\" fill=\"currentColor\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.0007 15.828L12.0507 20.778L10.6367 19.364L17.0007 13L23.3647 19.364L21.9507 20.778L17.0007 15.828Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/deplierred.svg
// module id = 436
// module chunks = 0